<template>
  <div :class="disabled ? 'disabled' : ''" class="checkbox">
    <label class="d-flex gap-2 align-items-center mt-1">
      <input
        :id="id ?? name"
        :checked="value ?? false"
        :disabled="disabled"
        :name="name"
        class="form-check-input"
        type="checkbox"
        @change="updateData($event.target.checked)"
      />
      <div class="check rounded-0 fs-5" :style="disabled ? 'color:#e9ecef;' : ''"></div>
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, default: () => '' },
    name: { type: String, default: () => '' },
    label: { type: String, default: () => '' },
    value: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const updateData = (data) => {
      emit('update:data', data);
    };

    return {
      updateData,
    };
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  input[type='checkbox'] + .check {
    height: 1.25rem;
    width: 1.25rem;
    min-width: 1.25rem;
  }
}
</style>
